import { createApp } from 'vue';
import WishlistApp from './List.vue';
import AddToList from './AddToList.vue';
import FormWishlist from './FormWishlist.vue';

// Drawer wishlist — presente su tutte le pagine
const wishlistEl = document.getElementById('vue-wishlist');
if (wishlistEl) {
  const contactUrl = wishlistEl.dataset.contactUrl || '#';
  createApp(WishlistApp, { contactUrl }).mount(wishlistEl);
}

// Add-to-list button — solo sulla pagina prodotto
const addListEl = document.getElementById('vue-add-list');
if (addListEl) {
  const product = JSON.parse(addListEl.dataset.product || 'null');
  const icon = addListEl.dataset.icon || '';
  if (product) createApp(AddToList, { product, icon }).mount(addListEl);
}

// Riepilogo wishlist nel form contatti — solo pagina contatti
const formWishlistEl = document.getElementById('vue-form-wishlist');
if (formWishlistEl) {
  createApp(FormWishlist).mount(formWishlistEl);
}
